import * as React from "react";
import * as ReactDOM from "react-dom";
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import { SampleFileBase64 } from './SampleFileBase64.js';
import { useNavigate } from "react-router-dom";

const UserManual = () => {
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");

    return (
        <PDFViewer data={SampleFileBase64} style={{height: 1400 }} />
    );
};

export default UserManual;
